import React, { useState } from "react";
import RatingGray from "./../assets/icons/star_gray.png";
import "./BannerGame.scss";
import defaultImage from "../assets/images/default-image.png";
import { reactLocalStorage } from "reactjs-localstorage";
import RatingYellow from "./../assets/icons/complete.png";
import RatingQuatar from "./../assets/icons/quatar.png";
import RatingHalf from "./../assets/icons/half.png";
import { FaPlay } from "react-icons/fa";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { redirectToSubUrl } from "../utils";

function PromoBannerGamePage(props) {
  let { search } = useLocation();
  const { uid,rcid,camp } = queryString.parse(search);
  const { game, color, play_btn_txt, sub_url,gamePlayEvent,checkSub } = props;
  const { id, bannerImage, gameName, gamePlayed, ratings, url } = game;
  const [showMore, setShowMore] = useState(false);

  function rating(number) {
    const num = parseFloat(number);
    let newArray = Array(5)
      .fill()
      .map((_, i) => {
        return (
          <img
            key={i}
            src={RatingYellow}
            alt="stars"
            className="mr-1 rating-icon"
          />
        );
      });
    newArray[4] =
      num == 4 ? (
        <img src={RatingGray} alt="stars" className="mr-1 rating-icon" />
      ) : num >= 4.0 && num <= 4.2 ? (
        <img src={RatingQuatar} alt="stars" className="mr-1 rating-icon" />
      ) : num >= 4.3 && num <= 4.5 ? (
        <img src={RatingHalf} alt="stars" className="mr-1 rating-icon" />
      ) : num >= 4.5 && num <= 4.7 ? (
        <img src={RatingHalf} alt="stars" className="mr-1 rating-icon" />
      ) : (
        <img src={RatingYellow} alt="stars" className="mr-1 rating-icon" />
      );
    return newArray;
  }
  function addDefaultSrc(e) {
    e.target.src = defaultImage;
  }

  async function handleClick() {
    if (uid || reactLocalStorage.get("uid")) {
      await checkSub({ uid: uid || reactLocalStorage.get("uid") });
    } else if (reactLocalStorage.get("msisdn")) {
      await checkSub({ msisdn: reactLocalStorage.get("msisdn") });
    } else {
      console.log("No uid or msisdn found, redirecting to home");
      redirectToSubUrl(sub_url, rcid, camp,game.id,game.category);
    }
  }

  return (
    <div className=" is-gapless pagebanner" style={{ minHeight: "50vh" }}>
      <div className=" p-r">
        <figure className="lazy-image image">
          <img src={bannerImage} onError={addDefaultSrc} alt="demo" />
        </figure>
        <div className="fixb">
          <div
            className="media"
            style={{
              width: "90%",
              whiteSpace: "break-spaces",
              bottom: "-2rem",
            }}
          >
            <div
              className="media-left"
              style={{ textAlign: "left", marginTop: "25vh", width: "60%" }}
            >
              <h5 className="title is-capitalized is-5 pb-2 has-text-white mb-4">
                {gameName}
              </h5>
              <h6 className="subtitle is-7 has-text-white mb-1 text-lg">
                {gamePlayed}
              </h6>
              <div className="rating has-text-white">
                {rating(ratings)}
                <small className="has-text-weight-dark">{ratings}</small>
              </div>
            </div>
            <div className="media-right">
              <div onClick={handleClick}>
                <div className="playBtn display">
                  <FaPlay color={color} className="m-auto" />
                  <span style={{ color: color }} className="m-auto align bold">
                    {play_btn_txt}
                  </span>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="column mt-4">
        <div className="p-2">
          <p className="subtitle is-6 has-text-white game-desc">
            {game?.gameDescription?.length <= 200
              ? game?.gameDescription
              : `${
                  game?.gameDescription?.length > 200 && showMore
                    ? `${game?.gameDescription}`
                    : `${game?.gameDescription.substring(0, 200)} ...`
                }`}
            {game?.gameDescription?.length > 200 && (
              <button
                onClick={() => setShowMore(!showMore)}
                className="toggle-btn p-2 mr-2 font-sm pink-btn"
              >
                {!showMore ? "Montre plus" : "Montrer moins"}
              </button>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PromoBannerGamePage;
